<template>
    <div>
        <h2>Bejelentkezés</h2>
        <a-form 
            id="login-component-form"
            :form="loginForm"
            class="login-form"
            v-on:submit="formSubmit"
        >
            <a-form-item>
                <a-input
                    v-decorator="[
                        'userName',
                        {
                            rules: [{
                                required: true,
                                message: 'Kérjük írjon be felhasználónevet'
                            }]
                        }
                    ]"
                    placeholder="Felhasználónév"
                >
                    <a-icon
                        slot="prefix"
                        type="user"
                        style="color: rgba(0, 0, 0, 0.5)"
                    >

                    </a-icon>
                </a-input>
            </a-form-item>
            <a-form-item>
                <a-input
                    v-decorator="[
                        'password',
                        {
                            rules: [{
                                required: true,
                                message: 'Kérjük írjon be jelszavat'
                            }]
                        }
                    ]"
                    type="password"
                    placeholder="Jelszó"
                >
                    <a-icon
                        slot="prefix"
                        type="lock"
                        style="color: rgba(0, 0, 0, 0.5)"
                    >

                    </a-icon>
                </a-input>
            </a-form-item>
            <a-divider
                
            ></a-divider>
            <a-form-item>
                <a-checkbox
                    class="remember-button"
                    v-decorator="[
                        'rememberMe',
                        {
                            valuePropName: 'checked',
                            initialValue: true
                        }
                    ]"

                >
                    Emlékezzen rám
                </a-checkbox>
                <!-- <router-link class="forgot-button" :to="{name: 'forgotten-password'}">
                    <span >
                        Elfelejtett jelszó
                    </span>
                </router-link> -->
                <a-button
                    :loading="loginLoading"
                    type="primary"
                    html-type="submit"
                    class="login-form-button"
                >
                    Bejelentkezés
                </a-button>
                <div
                    
                >
                    <a-alert
                        v-if="loginError"
                        :message="loginError.message"
                        type="error"
                        :showIcon="true"
                        :closable="true"
                        :banner="true"
                        :afterClose="clearError"
                    />
                </div>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
import LocalStorage from '@/helpers/localstorage.js';
import axios from 'axios';
import { SET_FACTOR2 } from '../../store/action_types';
import { SET_SESSION_LENGTH } from '@/store/mutation_types';


export default {
    
    beforeCreate() {
        this.loginForm = this.$form.createForm(this);
    },

    data() {
        return {
            loginLoading: false,
            loginError: null
        }
    },

    methods: {
        formSubmit(e) {
    
            e.preventDefault();
            this.loginForm.validateFieldsAndScroll((err, vals) => {
                console.log('ERR', err);
                console.log('VALS', vals);
                if (!err) {
                    
                    this.loginLoading = true;

                    axios.post('/api/login', {
                        username: vals.userName,
                        password: vals.password
                    })
                    .then((res) => {
                        
                        this.loginLoading = false;
                        this.$store.commit({
                            type: SET_FACTOR2,
                            token: res.data.token,
                            uuid: res.data.uuid,
                            rememberMe: vals.rememberMe
                        })

                        this.$router.push({
                            name: 'sms'
                        })
                    })
                    .catch((err) => {
                        const errorResponse = err.response;
                        console.log('ERRRR', err);

                        let status = errorResponse.status
                        let message = errorResponse.data.message

                        if (status === 401 && !message) {
                            message = 'Hibás felhasználónév, vagy jelszó.'
                        }

                        this.loginError = {
                            message: `${status}: ${message}`
                        }
                        this.loginLoading = false;
                    })
                }
            })

        },

        clearError() {
            this.loginError = null;
        }
    }
}
</script>

<style lang="scss" scoped>
    h2 {
        text-align: center;
    }
    .forgot-button {
        float: right;
    }
    .remember-button {
        float:left;
    }
    .login-form-button {
        width: 100%
    }
</style>
